import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { SttTableService } from '../../../../shared/components/stt-table/stt-table-service';

@Component({
  selector: 'app-stock-raw-materials',
  templateUrl: './stock-raw-materials.component.html',
  styleUrls: ['./stock-raw-materials.component.scss']
})
export class StockRawMaterialsComponent implements OnInit {
    public tableEndpoint = 'stock/raw-materials';
    public tableQuery: any;
    public ref: DynamicDialogRef;
    public tableStyle  = 'p-datatable-striped p-datatable';

    constructor(public dialogService: DialogService,
                public router: Router) {
        this.tableQuery = new SttTableService()
            .addInclude('rawMaterial');
    }

    ngOnInit(): void {

    }

}
